/**
 * O TEXTO DO ITEM COMO SAI NA NOTA (16/10/2026, pedido do Heitor). O detalhe da nota em Notas Fiscais → Documentos
 * mostrava o `description` do item, mas o que vai para a nota é o `name`, e é no name que mora o "— Nota de Empenho nº X".
 * No rascunho #2244 (FAT202610045, SAMU) a tela dizia "Contrato 245/2023 - Solução de TI…" e escondia "Serviços TI SAMU
 * 192 — Nota de Empenho nº 29257/2026": não dava para ver se o empenho tinha entrado.
 *
 * Espelha o backend, regra por tipo:
 *  - NFS-e (nfse.service, buildDiscriminacao): `${productCode} - ${nome}` (sem código, só o nome);
 *    nome = name, senão productName, senão "Serviço de TI".
 *  - NFCom (nfcom.service): name, senão description, senão productName, senão "Serviço de comunicação"; cortado em
 *    120 caracteres; o código vai em campo próprio, não no texto.
 */
export type TipoDaNota = 'nfse' | 'nfcom' | string;

export function textoDoItemNaNota(item: any, tipo: TipoDaNota): string {
  if (tipo === 'nfcom') {
    return String(item?.name || item?.description || item?.productName || 'Serviço de comunicação').substring(0, 120);
  }
  const nome = item?.name || item?.productName || 'Serviço de TI';
  const codigo = item?.productCode || '';
  return codigo ? `${codigo} - ${nome}` : String(nome);
}

/** A descrição comercial, para ir embaixo e menor: só quando existe e não é o próprio texto da nota. */
export function descricaoAlemDoTexto(item: any, tipo: TipoDaNota): string | null {
  const d = String(item?.description || '').trim();
  if (!d) return null;
  const texto = textoDoItemNaNota(item, tipo);
  return texto === d || texto.endsWith(` - ${d}`) ? null : d;
}
